import { i } from "./index.es265.js";
import { _ as o } from "./index.es275.js";
import { _ as s } from "./index.es276.js";
import { t as a } from "./index.es277.js";
var m = i, n = o, _ = s, f = a;
function p(r, t) {
  return m(r) ? r : n(r, t) ? [r] : _(f(r));
}
var c = p;
export {
  c as _
};
//# sourceMappingURL=index.es97.js.map
